import productWiseSalesAnalyticsService from 'services/product-wise-sales-analytics-service'

// ------------------------------------
// Constants
// ------------------------------------
let LOAD_PRODUCT_WISE_SALES_ANALYTICS = 'LOAD_PRODUCT_WISE_SALES_ANALYTICS'
let LOAD_PRODUCT_WISE_SALES_ANALYTICS_FOR_CSV = 'LOAD_PRODUCT_WISE_SALES_ANALYTICS_FOR_CSV'
// ------------------------------------
// Actions
// ------------------------------------

// ------------------------------------
// Action Handlers
// ------------------------------------

export function loadProductWiseSalesAnalytics (filter, changesFrom) {
  return (dispatch, getState) => {
    return productWiseSalesAnalyticsService.getProductWiseSalesAnalyticsDetails(filter, changesFrom)
      .then((productWiseSalesDetails) => {
        dispatch({
          type: LOAD_PRODUCT_WISE_SALES_ANALYTICS,
          productWiseSalesDetails: productWiseSalesDetails
        })
      })
  }
}

export function loadProductWiseSalesAnalyticsForCSV (filter, changesFrom, isExportCSV) {
  return (dispatch, getState) => {
    return productWiseSalesAnalyticsService.getProductWiseSalesAnalyticsDetails(filter, changesFrom, isExportCSV)
      .then((productWiseSalesDetails) => {
        dispatch({
          type: LOAD_PRODUCT_WISE_SALES_ANALYTICS_FOR_CSV,
          productWiseSalesDetailsForCSV: productWiseSalesDetails
        })
      })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

export function productWiseSalesAnalyticsReducer (state = [{'check': 'ss'}], action) {
  switch (action.type) {
    case LOAD_PRODUCT_WISE_SALES_ANALYTICS: {
      return action.productWiseSalesDetails
    }
    default:
      return state
  }
}

export function productWiseSalesAnalyticsForCSVReducer (state = [{'check': 'ss'}], action) {
  switch (action.type) {
    case LOAD_PRODUCT_WISE_SALES_ANALYTICS_FOR_CSV: {
      return action.productWiseSalesDetailsForCSV
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/ProductWiseSalesAnalytics/modules/ProductWiseSalesAnalytics.js